module.exports = __webpack_public_path__ + "static/media/MCC-Crest.0000781c.jpg";